/** API-Orchestrierung fürs Übernehmen (Push). Bullets → Bullet1..5-Slots. */
import { applyContentField, type PushBlockType } from '@/lib/api/channel-content'

const BULLET_SLOTS: PushBlockType[] = ['Bullet1', 'Bullet2', 'Bullet3', 'Bullet4', 'Bullet5']

/**
 * Schreibt einen Feldwert nach JTL (reuse /descriptions/push). Bullets werden je
 * Slot einzeln gepusht; leere Slots löschen den Custom-Field (Backend-Verhalten).
 */
export async function applyFieldToChannel(
  productId: string,
  salesChannelId: string,
  attributeCode: string,
  value: string | string[],
): Promise<{ ok: boolean; error?: string }> {
  try {
    if (attributeCode === 'bullets' && Array.isArray(value)) {
      for (let i = 0; i < BULLET_SLOTS.length; i++) {
        await applyContentField(productId, {
          sales_channel_id: salesChannelId,
          block_type: BULLET_SLOTS[i],
          content: value[i] ?? '',
        })
      }
    } else {
      await applyContentField(productId, {
        sales_channel_id: salesChannelId,
        block_type: attributeCode as PushBlockType,
        content: String(value),
      })
    }
    return { ok: true }
  } catch (e) {
    return { ok: false, error: e instanceof Error ? e.message : 'Push fehlgeschlagen' }
  }
}
